import { React, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { useLanguage } from '../../../Context/LanguageContext';
import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';

import Notice from '../../../Component/MainComponent/Notice.js';

import NoticeList from '../NoticeModel/NoticeList.js';
import Pagination from '../../../Component/MainComponent/NoticePagination.js';

import FetchModule from '../../Share/Network/FetchModule.js';

const NoticeView = () => {
  const history = useHistory();
  const { t } = useLanguage();
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  const [data, setData] = useState([]);
  const [useData, setUseData] = useState([]);
  const [nowPage, setNowPage] = useState(1);
  
  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postData('notice/', 'POST');

        if (responseData.status === 200) setData(responseData.data);
        else if (responseData.status !== 204) {}
      }
    )();
  }, [history])

  useEffect(() => {
    var newDataList = data.slice((nowPage - 1) * 12, (nowPage) * 12);
    setUseData(newDataList);
  }, [nowPage, data])

  function clickNextPage() {
    if (nowPage >= Math.ceil(data.length/12)) return;

    setNowPage(nowPage + 1);
  }

  function clickPrevPage() {
    if (nowPage <= 1) return;

    setNowPage(nowPage - 1);
  }

  return (
    <TopLevelWrapper isDark={isDark}>
      <TitleWrapper>
        <Text fontFamily='NotoSansKR-Bold' fontSize={16} color={theme.text} cursor='default' style={{ marginTop: '28px' }}>{t('main.notice.title')}</Text>
        <ExplanationWrapper>
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subText} cursor='default'>{t('main.notice.desc')}</Text>
          <Text fontFamily='NotoSansKR-Medium' fontSize={12} color={theme.primary} cursor='pointer' onClick={() => history.push('/notice')} style={{ whiteSpace: 'nowrap' }}>{t('main.notice.viewAll')}</Text>
        </ExplanationWrapper>
      </TitleWrapper>
      <ViewBox>
        <ListBox>
          <Notice data={useData}/>
        </ListBox>
      <Pagination 
        nowPage={nowPage} 
        totalPage={Math.ceil(data.length/12)} 
        prevFn={clickPrevPage} 
        nextFn={clickNextPage}/>
      </ViewBox>
    </TopLevelWrapper>
  )
};

export default NoticeView;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 1059px;
  height: 592px;

  border-radius: 30px;
  background-color: ${props => props.theme.subBackground};
  box-shadow: ${props => props.isDark ? 'none' : '0px 40px 50px rgba(240, 232, 227, 0.5)'};

  margin-bottom: 96px;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const ExplanationWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 1019px;
  margin-top: 4px;
  margin-bottom: 24px;
`;

const ViewBox = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  width: 1019px;
  height: 448px;

  gap: 16px;
  padding-top: 20px;
  margin-bottom: 27px;

  border-top: 2px solid ${props => props.theme.line};
`;

const ListBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  transition: all 0.3s ease-in-out;

  @media (hover: hover) {
    &:hover {
      cursor: ${props => props.cursor};
    }
  }
`;
